import React, { FC, useLayoutEffect, useState } from "react";
import AnyReactComponent from "components/AnyReactComponent/AnyReactComponent";
import GoogleMapReact from "google-map-react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Heading2 from "components/Heading/Heading2";
import CarCardH from "components/CarCardH/CarCardH";
import { ManyItem } from "types/interfaces";
import { BorderCoor, LatLng } from "types/map";

export interface SectionGridHasMapProps {
  loading: boolean;
  className?: string;
  location?: string;
  data?: Array<ManyItem>;
  onChange: (coor: BorderCoor) => void;
}

const SectionGridHasMap: FC<SectionGridHasMapProps> = ({
  loading,
  className,
  location = "",
  data = [],
  onChange = () => {},
}) => {
  const [filterWord, setFilterWord] = useState("");
  const [currentHoverID, setCurrentHoverID] = useState<string | number>(-1);
  const [showFullMapFixed, setShowFullMapFixed] = useState(false);
  const [latLng, setLatLng] = useState<LatLng>({
    lat: -8.746188649054744,
    lng: 115.16688996079675,
  });

  const fileredData = data.filter((item) => {
    return item.name.toLowerCase().includes(filterWord.toLowerCase());
  });

  const uppercaseFirstLetter = (str: string) => {
    if (str.includes("-")) {
      return str
        .split("-")
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
        .join(" ");
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  useLayoutEffect(() => {
    if (location) {
      switch (location) {
        case "kintamani":
          setLatLng({ lat: -8.24617992726016, lng: 115.37927138217543 });

          break;
        case "buyan":
          setLatLng({ lat: -8.25572491773319, lng: 115.13416220914308 });

          break;
        case "denpasar-barat":
          setLatLng({ lat: -8.66737616863549, lng: 115.19316684118628 });

          break;
        case "denpasar-timur":
          setLatLng({ lat: -8.642960500165858, lng: 115.24939347231921 });

          break;
        case "denpasar-selatan":
          setLatLng({ lat: -8.703612263005207, lng: 115.21074009108801 });

          break;
        case "denpasar-utara":
          setLatLng({ lat: -8.625149351770723, lng: 115.21128751782038 });

          break;
        case "karangasem":
          setLatLng({ lat: -8.431249408946002, lng: 115.51605585523028 });
          break;
        default:
          setLatLng({ lat: -8.746188649054744, lng: 115.16688996079675 });
      }
    }
  }, [location]);

  return (
    <div className={className}>
      <div className="relative flex min-h-screen">
        {/* CARDSSSS */}
        <div className="min-h-screen w-full xl:w-[780px] 2xl:w-[880px] flex-shrink-0 xl:px-8 ">
          <Heading2
            heading={`Barang sewa${
              location ? " di " + uppercaseFirstLetter(location) : ""
            }`}
            subHeading={
              <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
                {fileredData.length} Barang{" "}
                {filterWord && (
                  <span>
                    dengan kata kunci{" "}
                    <strong className="text-primary-6000">
                      {filterWord.toLowerCase()}
                    </strong>
                  </span>
                )}
              </span>
            }
            filter={true}
            onFilterChange={(e) => setFilterWord(e.target.value)}
          />

          {/* <div className="mb-8 lg:mb-11">
            <TabFilters />
          </div> */}
          <div className="grid grid-cols-1 gap-8">
            {loading
              ? [1, 2, 3, 4, 5].map((v) => {
                  return <CarCardH key={v} loading={loading} />;
                })
              : fileredData.map((item) => (
                  <div
                    key={item._id}
                    onMouseEnter={() => setCurrentHoverID((_) => item._id)}
                    onMouseLeave={() => setCurrentHoverID((_) => -1)}
                  >
                    <CarCardH key={item._id} data={item} />
                  </div>
                ))}
          </div>
          <div className="flex mt-16 justify-center items-center">
            {!fileredData.length && (
              <div className="mt-8">Barang tidak ditemukan</div>
            )}
            {/* <Pagination /> */}
          </div>
        </div>

        <div
          className="flex xl:hidden items-center justify-center fixed bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-2 bg-neutral-900 text-white shadow-2xl rounded-full z-30  space-x-3 text-sm cursor-pointer"
          onClick={() => setShowFullMapFixed(true)}
        >
          <i className="text-lg las la-map"></i>
          <span>Show map</span>
        </div>

        {/* MAPPPPP */}
        <div
          className={`xl:flex-grow xl:static xl:block ${
            showFullMapFixed ? "fixed inset-0 z-50" : "hidden"
          }`}
        >
          {showFullMapFixed && (
            <ButtonClose
              onClick={() => setShowFullMapFixed(false)}
              className="bg-white absolute z-50 left-3 top-3 shadow-lg rounded-xl w-10 h-10"
            />
          )}

          <div className="fixed xl:sticky top-0 xl:top-[88px] left-0 w-full h-full xl:h-[calc(100vh-88px)] rounded-md overflow-hidden">
            {/* <div className="absolute bottom-5 left-3 lg:bottom-auto lg:top-2.5 lg:left-1/2 transform lg:-translate-x-1/2 py-2 px-4 bg-white shadow-xl z-10 rounded-2xl min-w-max">
              <Checkbox
                className="text-xs xl:text-sm text-neutral-800"
                name="xx"
                label="Search ass I move the map"
              />
            </div> */}
            {/* BELLOW IS MY GOOGLE API KEY -- PLEASE DELETE AND TYPE YOUR API KEY */}

            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyAYuFE0a7MCk8Xxd-EYY-ps-mpW_oTQCnU",
              }}
              defaultZoom={13}
              options={{ maxZoom: 15, minZoom: 12 }}
              yesIWantToUseGoogleMapApiInternals
              onChange={(e) => {
                onChange(e.bounds);
              }}
              defaultCenter={{
                lat: 8.746188649054744,
                lng: 115.16688996079675,
              }}
              center={latLng}
            >
              {fileredData.map((item) => {
                return (
                  <AnyReactComponent
                    key={item._id}
                    isSelected={currentHoverID === item._id}
                    lat={item.address.map?.latitude || 8.746188649054744}
                    lng={item.address.map?.longitude || 115.16688996079675}
                    item={item}
                  />
                );
              })}
            </GoogleMapReact>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionGridHasMap;
